var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 26,
    rx: 5,
    fill: "#26CD9F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9972 11.7676C20.3313 12.5373 20.3313 14.4627 18.9972 15.2324L11.9994 19.2696C10.6661 20.0388 9 19.0765 9 17.5372L9 9.46282C9 7.9235 10.6661 6.96122 11.9994 7.73045L18.9972 11.7676Z",
    fill: "#12233D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/play-icon.d0e8d8ae06ae26369a001a314425ae04.svg";
export { ForwardRef as ReactComponent };